// import SpoilService from '@/services/requests/spoilService'
import Store from '@/store/computed/storeHelpers'
import Api from '@/services/api'

export default {
  methods: {
    getSpoils() {
      this.loadingSpoils = true
      var urlString = 'spoils'
      if (!!this.includeInactive) urlString += '/includeInactive'
      return Api.get(urlString)
        .then(result => {
          this.loadingSpoils = false
          this.spoils = result.data.result
          return result.data.result
        })
        .catch(err => {
          console.log(err)
          this.loadingSpoils = false
          this.snackError()
        })
    }
  },
  computed: {
    loadingSpoils: Store.getSet({ store: 'spoils', prop: 'loadingSpoils' }),
    spoils: Store.getSet({ store: 'spoils', prop: 'spoils' })
  },
  mounted() {
    if (!this.spoils.length && this.$route.name !== 'audit') {
      this.getSpoils()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.spoils = []
  }
}
